import {Component, inject, Input} from '@angular/core';
import {ReportingService} from "../../../services/reporting.service";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {IDateRangeReportingData} from "../../../interfaces/reporting/IDateRangeReportingData";
import {
  ComponentLevelErrorMessageComponent
} from "../../display-errors/component-level-error-message/component-level-error-message.component";
import {LoadingCardContentComponent} from "../../../shared/loading-card-content/loading-card-content.component";
import {DatePipe} from "@angular/common";
import {PipesModule} from "../../../pipes/pipes.module";
import {AgGridAngular} from "ag-grid-angular";
import {ColDef} from "ag-grid-community";
import {FormatCurrencyPipe} from "../../../pipes/format-currency.pipe";
import {ISalesSummaryByPricePointReport} from "../../../interfaces/reporting/ISalesSummaryByPricePointReport";

@Component({
  selector: 'app-price-point-report',
  standalone: true,
  templateUrl: './price-point-report.component.html',
  imports: [
    ComponentLevelErrorMessageComponent,
    LoadingCardContentComponent,
    DatePipe,
    PipesModule,
    AgGridAngular
  ],
  styleUrls: ['./price-point-report.component.css']
})
export class PricePointReportComponent {

  private reportingService: ReportingService = inject(ReportingService);
  private currencyPipe: FormatCurrencyPipe = inject(FormatCurrencyPipe);

  @Input() set dateRangesSetter(valueP: IDateRangeReportingData) {
    this.dateRanges = valueP;
    this.reportingService.getSalesSummaryByPricePointReport(
      valueP.Game.Id,
      valueP.StartDate,
      valueP.EndDate
    ).subscribe({
      next: (reportResP) => {
        this.pricePointReport = reportResP;
        this.uiState = UIStateEnum.ShowData;
      },
      error: () => {
        this.errorMessage = 'There was an issue retrieving your sales summary by price point report. ' +
          'Please try refreshing the page or reaching out to a system administrator.';
        this.uiState = UIStateEnum.ShowData;
      }
    })
  }

  public pricePointReportDefs: ColDef[] = [
    {
      headerName: 'Price Point',
      resizable: true,
      sortable: true,
      field: 'PricePoint',
      flex: 1,
      valueFormatter: params => {
        const converted = this.currencyPipe.transform(params.value);
        return converted ? converted : '';
      }
    },
    {
      headerName: 'Ticket Strips Sold',
      resizable: true,
      sortable: true,
      field: 'TicketStripsSold',
      flex: 1
    },
    {
      headerName: 'Total Sales Value',
      resizable: true,
      sortable: true,
      field: 'TotalSalesValue',
      flex: 1,
      valueFormatter: params => {
        const converted = this.currencyPipe.transform(params.value);
        return converted ? converted : '';
      }
    }
  ];

  public uiState = UIStateEnum.ShowLoading;
  public uiStateForTemplate = UIStateEnum;
  public errorMessage = '';
  public pricePointReport!: ISalesSummaryByPricePointReport;
  public dateRanges!: IDateRangeReportingData;
}
